<template>
  <div>
    <template v-if="!loading">
      <invoice-header :celebration="celebration" :description="description" :status="status"></invoice-header>
      <div class="container">
        <div class="row row-wrap">
          <div class="col-1">
            <div class="item-box">
              <div class="item-box-header"><h4>Cliente</h4></div>
              <div class="item-box-content">
                <div class="row row-wrap">
                  <div class="col-1 col-sm-2">
                    <h5>CPF/CNPJ</h5>
                    {{ customerDocument | document }}
                  </div>
                  <div class="col-1 col-sm-2">
                    <h5>Nome</h5>
                    {{ customerName }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="col-1 col-sm-2">
            <div class="item-box">
              <div class="item-box-header"><h4>Cedente</h4></div>
              <div class="item-box-content">
                <div class="row">
                  <div class="col">
                    <h5>CPF/CNPJ</h5>
                    {{ financialDocument | document }}
                    <br><br>
                  </div>
                  <div class="col">
                    <h5>Conta Heppi</h5>
                    {{ financialAccount }}
                    <br><br>
                  </div>
                </div>
                <h5>Nome</h5>
                {{ financialName }}
              </div>
            </div>
          </div> -->
        </div>
        <div class="item-box">
          <div class="item-box-header"><h4>Detalhes da fatura</h4></div>
          <div class="item-box-content">
            <template v-if="items.length > 0">
              <h5>{{ type | typeDescription }}</h5>
              <ul class="list-content">
                <li class="list-item" v-for="(item, index) in items" :key="'item-' + index">
                  <div class="list-item-qty" v-if="type !== 'fundraising'">
                    {{ item.qty }}x
                  </div>
                  <div class="list-item-content">
                    <div v-if="item.type === 'fundraising'" class="list-item-subtitle">Parcela</div>
                    <div v-if="item.type === 'renegotiation'" class="list-item-subtitle">Renegociação/Acordo</div>
                    <div v-if="item.type === 'additional'" class="list-item-subtitle">Adicional</div>
                    <div class="list-item-text">{{ item.description }}</div>
                  </div>
                  <div class="list-item-value">
                    {{ (item.value * item.qty) | priceInteger }}<small>,{{ (item.value * item.qty) | priceCents }}</small>
                  </div>
                </li>
              </ul>
            </template>
            <template v-if="discounts.length > 0">
              <h5>Descontos</h5>
              <ul class="list-content">
                <li class="list-item" v-for="(item, index) in discounts" :key="'discounts-' + index">
                  <div class="list-item-content">
                    <div class="list-item-text">{{ item.description }}</div>
                  </div>
                  <div class="list-item-value">
                    {{ item.value | priceInteger }}<small>,{{ item.value | priceCents }}</small>
                  </div>
                </li>
              </ul>
            </template>
            <template v-if="others.length > 0">
              <h5>Multa e Juros</h5>
              <ul class="list-content">
                <li class="list-item" v-for="(item, index) in others" :key="'others-' + index">
                  <div class="list-item-content">
                    <div class="list-item-text">{{ item.description }}</div>
                  </div>
                  <div class="list-item-value">
                    {{ item.value | priceInteger }}<small>,{{ item.value | priceCents }}</small>
                  </div>
                </li>
              </ul>
            </template>
            <div class="separator" />
            <div class="detais-content row row-wrap">
              <div v-if="status === 'paid' || status === 'processing'" class="details-total col">
                <div v-if="paymentInfo.method === 'bank_slip'" class="total-value slip-bank">
                  <span>&nbsp;</span>
                  {{ paymentInfo.total | priceInteger }}<small>,{{ paymentInfo.total | priceCents }}</small>
                  <span>no boleto</span>
                </div>
                <div v-else-if="paymentInfo.method === 'pix'" class="total-value slip-bank">
                  <span>&nbsp;</span>
                  {{ paymentInfo.total | priceInteger }}<small>,{{ paymentInfo.total | priceCents }}</small>
                  <span>no PIX</span>
                </div>
                <div v-else class="total-value credit-card">
                  <span class="installment-qty" v-if="paymentInfo.installments > 1">{{ paymentInfo.installments }}x</span>
                  {{ paymentInfo.total / (paymentInfo.installments || 1) | priceInteger }}<small>,{{ paymentInfo.total / (paymentInfo.installments || 1) | priceCents }}</small>
                  <span>no cartão</span>
                </div>
              </div>
              <!-- <div v-else class="details-total col">
                <div v-if="maxInstallments > 0" class="total-value credit-card">
                  <span class="installment-qty" v-if="maxInstallments > 1">{{ maxInstallments }}x</span>
                  {{ total['creditCard' + maxInstallments] / maxInstallments | priceInteger }}<small>,{{ total['creditCard' + maxInstallments] / maxInstallments | priceCents }}</small>
                  <span>no cartão</span>
                </div>
                <div v-if="total.pix" class="total-value pix">
                  {{ total.pix | priceInteger }}<small>,{{ total.pix | priceCents }}</small>
                  <span>no PIX</span>
                </div>
                <div v-if="total.bankSlip" class="total-value slip-bank">
                  {{ total.bankSlip | priceInteger }}<small>,{{ total.bankSlip | priceCents }}</small>
                  <span>no boleto</span>
                </div>
              </div> -->
              <div class="due-date col text-uppercase">
                <h5>Vencimento</h5>
                {{ dueDate | moment('DD MMM YYYY') }}
              </div>
              <div v-if="paymentDate" class="due-date col text-uppercase">
                <h5>Pagamento</h5>
                {{ paymentDate | moment('DD MMM YYYY') }}
              </div>
              <div class="share-button col">
                <button v-if="status === 'paid' || status === 'partially_paid'" class="button button-primary" @click="$router.push({ name: 'receipt', params: { id } })">
                  <img src="@/assets/images/receipt-negative.png" srcset="@/assets/images/receipt-negative@2x.png 2x">
                  Abrir recibo
                </button>
                <button v-else class="button button-primary" @click="shareInvoice()">
                  <img v-if="deviceType === 'ios'" src="@/assets/images/share-ios.png" srcset="@/assets/images/share-ios@2x.png 2x">
                  <img v-else src="@/assets/images/share-android.png" srcset="@/assets/images/share-android@2x.png 2x">
                  Compartilhar fatura
                </button>
                <button style="width: 1px; opacity: 0;" ref="getnetButton" class="pay-button-getnet"></button>
              </div>
            </div>
          </div>
        </div>
        <div v-if="maxInstallments > 0 && canPaid" id="creditCardPayment" class="item-box">
          <div class="item-box-header">
            <h3>Pagamento no cartão</h3>
          </div>
          <div class="item-box-content">
            <div class="row row-wrap justify-content-center align-items-center">
              <div class="col total-value-only">
                <small><template v-if="maxInstallments > 1">Até {{ maxInstallments }}x de </template>R$</small> {{ total['creditCard' + maxInstallments] / maxInstallments | priceInteger }}<small>,{{ total['creditCard' + maxInstallments] / maxInstallments | priceCents }}</small>
              </div>
              <button class="button button-success" @click="payCreditCard()" :disabled="creditCardOpened">
                <img src="@/assets/images/payment-credit-card.png" srcset="@/assets/images/payment-credit-card@2x.png 2x" />
                Pagar com cartão
              </button>
            </div>
            <credit-card-form v-if="creditCardOpened" :key="'creditCardKey-'+creditCardKey" :fees="fees" :total="total" :max-installments="maxInstallments" :credit-card-data="creditCardData" @error="creditCardError" :pagseguroKey="pagseguroToken" @sending="sending = true" @pay-proceed="payWithPagSeguro"></credit-card-form>
          </div>
        </div>
        <div v-if="total.pix && canPaid" class="item-box">
          <div class="item-box-header">
            <h3>Pagamento no PIX</h3>
          </div>
          <div class="item-box-content">
            <div class="row row-wrap justify-content-center align-items-center">
              <div class="col total-value-only">
                <small>R$</small> {{ total.pix | priceInteger }}<small>,{{ total.pix | priceCents }}</small>
              </div>
              <button class="button button-success" @click="payWithPix()">
                <img src="@/assets/images/payment-pix.png" srcset="@/assets/images/payment-pix@2x.png 2x" />
                Pagar com PIX
              </button>
            </div>
          </div>
        </div>
        <!-- <div v-if="total.bankSlip && canPaid" class="item-box">
          <div class="item-box-header">
            <h3>Pagamento no boleto</h3>
          </div>
          <div class="item-box-content">
            <div class="row row-wrap justify-content-center align-items-center">
              <div class="col total-value-only">
                <small>R$</small> {{ total.bankSlip | priceInteger }}<small>,{{ total.bankSlip | priceCents }}</small>
              </div>
              <button class="button button-success" @click="payWithBankSlip()">
                <img src="@/assets/images/payment-bank-slip.png" srcset="@/assets/images/payment-bank-slip@2x.png 2x" />
                Pagar com boleto
              </button>
            </div>
          </div>
        </div>-->
      </div>
      <invoice-footer :gateway="gateway"></invoice-footer>
    </template>
    <loading v-if="loading || sending" :loading-text="loadingText"></loading>
    <modal v-else-if="openSharing" modal-header="Compartilhar fatura">
      <p>Para compartilhar a fatura com outras pessoas é só copiar o link abaixo:</p>
      <div class="form-group">
        <input ref="input-copy" class="form-input" :value="url" type="text" readonly="true">
        <div class="copy-append" :class="{ 'muted': copiedLink }" @click="copyLink()">{{ (copiedLink) ? 'Copiado!' : 'Copiar' }}</div>
      </div>
      <br><br>
      <!--<input type="text" class="input-copy" ref="input-copy" :value="url" readonly @click="copyLink()" /><button @click="copyLink()" class="button button-primary">Copiar</button>
      <br><br>-->
      <div class="text-right">
        <button @click="openSharing = false" class="button button-outline-primary">Fechar</button>
      </div>
    </modal>
    <modal v-else-if="openCreditCardResponse" :modal-header="statusCreditCardResponse.title">
      <p>{{ statusCreditCardResponse.message }}</p>
      <br>
      <div class="text-right">
        <button @click="openCreditCardResponse = false" class="button button-primary">Entendi</button>
      </div>
    </modal>
    <modal v-else-if="openBankSlipError" modal-header="Problema no servidor">
      <p>Desculpe, mas houve um erro no nosso servidor ao tentar processar o seu boleto, por favor tente novamente.</p>
      <br>
      <div class="text-right">
        <button @click="openBankSlipError = false" class="button button-primary">Entendi</button>
      </div>
    </modal>
    <modal v-else-if="openPixResponse" modal-header="Pagamento no PIX" :hasCloseButton="true" @close="openPixResponse = false">
      <p>Pronto! Agora, basta escanear o QR Code abaixo ou copiar e colar o link no seu Internet Banking:</p>
      <div class="text-center">
        <img :src="pix.qrCode" style="max-height: 250px" />
      </div>
      <div class="form-group">
        <input id="pix-to-copy" class="form-input" :value="pix.code" type="text" readonly="true">
        <div class="copy-append" :class="{ 'muted': copied }" @click="copyPixCode()">{{ (copied) ? 'Copiado' : 'Copiar' }}</div>
      </div>
      <br>
    </modal>
    <modal v-else-if="openBankSlipResponse" modal-header="Pagamento no Boleto">
      <p>Pronto! Seu boleto já está disponível. Você pode copiar o código de barras abaixo ou abrir o boleto.</p>
      <div class="form-group">
        <input id="bar-code-to-copy" class="form-input" :value="bankSlip.barcode" type="text" readonly="true">
        <div class="copy-append" :class="{ 'muted': copied }" @click="copyBarCode()">{{ (copied) ? 'Copiado' : 'Copiar' }}</div>
      </div>
      <br><br>
      <div class="text-right">
        <button @click="openBankSlipResponse = false" class="button button-inverted-primary">Cancelar</button>
        &nbsp;&nbsp;
        <a :href="bankSlip.url" class="button button-primary">Abrir boleto</a>
      </div>
    </modal>
    <modal v-if="checkoutSuccess">
      <div style="padding: 16px;">
        <!-- <div class="text-center" style="padding-bottom: 12px;">
          <img src="@/assets/images/success.svg" height="50px" />
        </div> -->
        <h2 class="modal-header text-success text-bold" style="justify-content: start;"><img src="@/assets/images/success.svg" height="36px" style="margin-right: 12px;" /> Pagamento efetivado!</h2>
        <p>Sua transação foi <b>concluída</b> e está <b>tudo certo</b> com o seu pagamento.</p>
        <p>Devido ao processamento do sistema, o status de pagamento pode levar <b>até algumas horas</b> para ser atualizado em todos os nossos canais.</p>
        <p>Se tiver qualquer dúvida, entre em contato com nosso suporte.</p>
        <br>
        <div class="text-right">
          <button @click="checkoutSuccess = false" class="button button-success">Entendi</button>
        </div>
      </div>
    </modal>
    <modal v-if="checkoutError">
      <div style="padding: 16px;">
        <!-- <div class="text-center" style="padding-bottom: 12px;">
          <img src="@/assets/images/success.svg" height="50px" />
        </div> -->
        <h2 class="modal-header text-bold" style="justify-content: start;">Erro no pagamento!</h2>
        <p>Desculpe, mas não foi possivel processar seu pagamento.</p>
        <p>Se tiver qualquer dúvida, entre em contato com nosso suporte.</p>
        <br>
        <div class="text-right">
          <button @click="checkoutError = false" class="button button-danger">Entendi</button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import InvoiceHeader from '@/components/InvoiceHeader'
import InvoiceFooter from '@/components/InvoiceFooter'
import Loading from '@/components/Loading'
import Modal from '@/components/Modal'
import CreditCardForm from '@/components/CreditCardForm'
import { mapMutations } from 'vuex'
import axios from 'axios'

export default {
  name: 'invoice',
  components: {
    InvoiceHeader,
    InvoiceFooter,
    Loading,
    Modal,
    CreditCardForm
  },
  props: ['id'],
  data: () => {
    return {
      loading: false,
      sending: false,
      openSharing: false,
      openCreditCardResponse: false,
      openBankSlipError: false,
      type: null,
      monthReference: '',
      productReference: '',
      celebration: '',
      invoiceDescription: null,
      status: null,
      customerDocument: '',
      customerID: '',
      customerName: '',
      customerPhone: '',
      customerEmail: '',
      customerAddress: {},
      financialDocument: '',
      financialName: '',
      financialAccount: '',
      items: [],
      others: [],
      discounts: [],
      fees: {},
      dueDate: '',
      paymentDate: null,
      paymentInfo: {
        method: '',
        installments: 0,
        total: 0
      },
      creditCardOpened: false,
      creditCardData: {},
      creditCardKey: 0,
      openBankSlipResponse: false,
      bankSlip: {
        barcode: '',
        url: ''
      },
      openPixResponse: false,
      pix: {
        code: '',
        qrCode: ''
      },
      copied: false,
      copiedLink: false,
      gateway: 'mercado-pago',
      pixTimeout: null,
      pixUpdateCounter: 0,
      lastBankSlipGenerated: null,
      getnetToken: null,
      selectedMethod: 'pix',
      checkoutSuccess: false,
      checkoutError: false,
      lastApiData: null,
      pagseguroToken: null
    }
  },
  computed: {
    url () {
      let url = window.location + ''
      return url.split('#')[0]
    },
    canPaid () {
      return (this.status === 'pending' || this.status === 'late')
    },
    loadingText () {
      return (this.sending) ? 'Processando' : 'Carregando'
    },
    description () {
      return (this.invoiceDescription && this.type !== 'fundraising') ? this.invoiceDescription : this.$moment(this.monthReference).format('MMMM YYYY')
    },
    maxInstallments () {
      let maxInstallments = 0
      if (Object.keys(this.fees).length > 0) {
        for (let i = 1; i <= 12; i++) {
          if (this.fees['creditCard' + i] && this.total['creditCard' + i] / i > 5) maxInstallments = i
        }
      }
      return maxInstallments
    },
    total () {
      let total = 0
      if (this.items && this.items.length > 0) for (let i = 0, l = this.items.length; i < l; i++) total += parseFloat(this.items[i].value * this.items[i].qty)
      if (this.others && this.others.length > 0) for (let i = 0, l = this.others.length; i < l; i++) total += parseFloat(this.others[i].value)
      if (this.discounts && this.discounts.length > 0) for (let i = 0, l = this.discounts.length; i < l; i++) total -= parseFloat(this.discounts[i].value)

      let allTotals = {}
      let feeKeys = Object.keys(this.fees)
      for (let i = 0, l = feeKeys.length; i < l; i++) {
        if ((this.fees[feeKeys[i]].increment)) {
          if (this.fees[feeKeys[i]].type === 'tax') allTotals[feeKeys[i]] = parseFloat(total + this.fees[feeKeys[i]].value).toFixed(2)
          else if (this.fees[feeKeys[i]].type === 'percent') allTotals[feeKeys[i]] = parseFloat(total + (Math.round(total * this.fees[feeKeys[i]].value) / 100)).toFixed(2)
        } else {
          allTotals[feeKeys[i]] = parseFloat(total).toFixed(2)
        }
      }

      return allTotals
    },
    deviceType () {
      if (/iphone|ipad|ipod/.test(window.userAgent)) {
        return 'ios'
      } else {
        return 'android'
      }
    },
    customerFirstName () {
      return this.customerName?.split(' ')?.[0] || this.customerName
    },
    customerLastName () {
      const splited = this.customerName?.split(' ')
      if (splited && splited.length > 1) {
        splited.shift()
        return splited.join(' ')
      }
      return ''
    },
    itemsToGetnet () {
      return JSON.stringify({
        name: this.type === 'fundraising' ? 'Arrecadação' : 'Experiência',
        description: this.celebration,
        value: this.total[this.selectedMethod || 'bankSlip'] || 0.00,
        quantity: 1,
        sku: 1
      })
    },
    methodNotAllowed () {
      if (this.selectedMethod === 'pix') return '["credito", "debito", "credito-autenticado", "credito-nao-autenticado", "debito-autenticado", "debito-nao-autenticado", "boleto", "qr-code"]'
      if (this.selectedMethod === 'bankSlip') return '["credito", "debito", "credito-autenticado", "credito-nao-autenticado", "debito-autenticado", "debito-nao-autenticado", "qr-code", "pix"]'
      return '["debito", "credito-autenticado", "credito-nao-autenticado", "debito-autenticado", "debito-nao-autenticado", "boleto", "qr-code", "pix"]'
    }
  },
  filters: {
    typeDescription (val) {
      if (val === 'fundraising') return 'Arrecadações'
      return 'Itens'
    }
  },
  methods: {
    ...mapMutations(['SET_ERROR_PAGE']),
    shareInvoice () {
      if (navigator.share) {
        navigator.share({
          title: 'Fatura Heppi',
          text: 'Olá! Estou compartilhando com você uma fatura Heppi - ' + this.celebration + '.',
          url: this.url
        })
      } else {
        this.openSharing = true
      }
    },
    copyPixCode () {
      let codeToCopy = document.getElementById('pix-to-copy')
      codeToCopy.select()
      codeToCopy.setSelectionRange(0, 99999) // For mobile devices
      navigator.clipboard.writeText(codeToCopy.value)

      this.copied = true
      setTimeout(() => {
        this.copied = false
        window.getSelection().removeAllRanges()
      }, 1000)
    },
    copyBarCode () {
      let codeToCopy = document.getElementById('bar-code-to-copy')
      codeToCopy.select()
      codeToCopy.setSelectionRange(0, 99999) // For mobile devices
      navigator.clipboard.writeText(codeToCopy.value)

      this.copied = true
      setTimeout(() => {
        this.copied = false
        window.getSelection().removeAllRanges()
      }, 1000)
    },
    openCreditCard () {
      this.creditCardOpened = true
      setTimeout(() => { window.location = '#creditCardPayment' }, 200)
    },
    creditCardError () {
      this.sending = false
      setTimeout(() => { window.location = '#creditCardPayment' }, 200)
    },
    payWithBankSlip () {
      // if (this.lastBankSlipGenerated && this.lastBankSlipGenerated.transaction.total_paid_amount === this.total.bankSlip) {
      //   window.location = this.lastBankSlipGenerated.transaction.external_resource_url
      // } else {
      //   let data = {
      //     payment_method: 'bank_slip',
      //     fee_id: this.fees.bankSlip.id
      //   }
      //   this.sending = true
      //   this.postPayment(data)
      // }
      this.sending = true
      this.selectedMethod = 'bankSlip'
      this.payWithGetnet()
    },
    payWithPix () {
      // let data = {
      //   payment_method: 'pix',
      //   fee_id: this.fees.pix.id
      // }
      this.sending = true
      this.selectedMethod = 'pix'
      this.payWithGetnet()
    },
    async payCreditCard () {
      // let data = {
      //   payment_method: 'pix',
      //   fee_id: this.fees.pix.id
      // }
      // this.sending = true
      // this.selectedMethod = 'creditCard1'
      // this.payWithGetnet()
      this.creditCardOpened = true
      const result = await axios.get('get-pagseguro-session', {
        baseURL: 'https://n8n-payments.heppi.io/webhook/',
        auth: {
          username: 'heppi-payment',
          password: 'quinze-matagal-pires-barco-09983'
        }
      })
      console.log(result?.data?.public_key)
      this.pagseguroToken = result?.data?.public_key
    },
    payWithGetnet () {
      if (document.getElementById('script-externo')) {
        console.log('Removendo o script externo...')
        document.getElementById('script-externo').remove()
      }
      console.log('inicio')
      const script = document.createElement('script')
      script.setAttribute('id', 'script-externo')
      script.setAttribute('async', true)
      script.setAttribute('src', 'https://checkout.getnet.com.br/loader.js')
      script.setAttribute('data-getnet-sellerid', '94ca477e-6007-4077-9f60-31a717a8a0c8')
      script.setAttribute('data-getnet-payment-methods-disabled', this.methodNotAllowed)
      script.setAttribute('data-getnet-token', `Bearer ${this.getnetToken}`)
      script.setAttribute('data-getnet-amount', this.total[this.selectedMethod])
      script.setAttribute('data-getnet-customerid', this.customerID)
      script.setAttribute('data-getnet-orderid', this.id)
      script.setAttribute('data-getnet-button-class', 'pay-button-getnet')
      script.setAttribute('data-getnet-installments', this.maxInstallments)
      script.setAttribute('data-getnet-customer-first-name', this.customerFirstName)
      script.setAttribute('data-getnet-customer-last-name', this.customerLastName)
      script.setAttribute('data-getnet-customer-document-type', 'CPF')
      script.setAttribute('data-getnet-customer-document-number', this.customerDocument)
      script.setAttribute('data-getnet-customer-email', this.customerEmail)
      script.setAttribute('data-getnet-customer-phone-number', this.customerPhone)
      script.setAttribute('data-getnet-customer-address-street', this.customerAddress?.street || 'Avenida Agamenon Magalhães')
      script.setAttribute('data-getnet-customer-address-street-number', this.customerAddress?.number || '2939')
      script.setAttribute('data-getnet-customer-address-complementary', this.customerAddress?.complement || '')
      script.setAttribute('data-getnet-customer-address-neighborhood', this.customerAddress?.neighborhood || 'Espinheiro')
      script.setAttribute('data-getnet-customer-address-city', this.customerAddress?.city || 'Recife')
      script.setAttribute('data-getnet-customer-address-state', this.customerAddress?.state || 'PE')
      script.setAttribute('data-getnet-customer-address-zipcode', this.customerAddress?.zip_code || '52021-220')
      script.setAttribute('data-getnet-customer-country', 'Brasil')
      script.setAttribute('data-getnet-items', this.itemsToGetnet)

      script.onload = () => {
        console.log('Script externo carregado com sucesso!')
        this.sending = false
        this.$refs.getnetButton.click()

        // Funções compatíveis com IE e outros navegadores
        var eventMethod = (window.addEventListener ? 'addEventListener' : 'attachEvent')
        var eventer = window[eventMethod]
        var messageEvent = (eventMethod === 'attachEvent') ? 'onmessage' : 'message'

        // Ouvindo o evento do loader
        eventer(messageEvent, async (e) => {
          var data = e.data || ''

          console.log('messageEvent', e)

          switch (data.status || data) {
            // Corfirmação positiva do checkout.
            case 'success':
              this.checkoutSuccess = true
              await axios.post('checkout', {
                invoiceId: this.id,
                productReference: this.productReference,
                paymentMethod: this.selectedMethod,
                amount: this.total[this.selectedMethod],
                status: 'success',
                data
              }, {
                baseURL: 'https://n8n-payments.heppi.io/webhook/',
                auth: {
                  username: 'heppi-payment',
                  password: 'quinze-matagal-pires-barco-09983'
                }
              })
              break

            // Notificação de que o IFrame de checkout foi fechado a aprovação.
            case 'close':
              console.log('Checkout fechado.')
              break

            // Notificação que um boleto foi registrado com sucesso
            case 'pending':
              await axios.post('checkout', {
                invoiceId: this.id,
                productReference: this.productReference,
                paymentMethod: this.selectedMethod,
                amount: this.total[this.selectedMethod],
                status: 'pending',
                data
              }, {
                baseURL: 'https://n8n-payments.heppi.io/webhook/',
                auth: {
                  username: 'heppi-payment',
                  password: 'quinze-matagal-pires-barco-09983'
                }
              })
              break

            // Notificação que houve um erro na tentativa de pagamento
            case 'error':
              await axios.post('checkout', {
                invoiceId: this.id,
                productReference: this.productReference,
                paymentMethod: this.selectedMethod,
                amount: this.total[this.selectedMethod],
                status: 'error',
                data
              }, {
                baseURL: 'https://n8n-payments.heppi.io/webhook/',
                auth: {
                  username: 'heppi-payment',
                  password: 'quinze-matagal-pires-barco-09983'
                }
              })
              break

            // Ignora qualquer outra mensagem
            default:
              break
          }
        }, false)
      }

      document.head.appendChild(script)
    },
    async payWithPagSeguro (data) {
      try {
        this.sending = true
        const total = this.total['creditCard' + data.installments]
        const phone = this.customerPhone
        const email = this.customerEmail
        const response = await axios.post('pagseguro-credit-card', {
          invoice_id: this.id,
          product_reference: this.productReference,
          description: this.celebration + ' - ' + this.description,
          total_amount: total,
          customer: {
            name: data.credit_card.identification_name, // Nome do comprador
            email, // E-mail (obrigatório)
            tax_id: data.credit_card.identification_number, // CPF/CNPJ (apenas números)
            phones: [
              {
                country: '55',
                area: phone.substring(0, 2), // DDD
                number: phone.substring(2, 200), // Número
                type: 'MOBILE'
              }
            ]
          },
          ...data
        }, {
          baseURL: 'https://n8n-payments.heppi.io/webhook/',
          auth: {
            username: 'heppi-payment',
            password: 'quinze-matagal-pires-barco-09983'
          }
        })

        if (response?.data?.status === 'PAID') {
          this.checkoutSuccess = true
        } else {
          this.checkoutError = true
        }
      } catch (e) {
        this.checkoutError = true
      }
      this.sending = false
    },
    postPayment (data) {
      let vue = this

      axios.post('checkout/' + vue.id, data)
        .then((response) => {
          vue.sending = false
          if (data.credit_card) {
            vue.openCreditCardResponse = true
            vue.status = (response.data.status === 'approved') ? 'paid' : 'processing'
            vue.statusCreditCardResponse = {
              status: response.data.status,
              title: (response.data.status === 'approved') ? 'Pagamento aprovado' : 'Pagamento em processamento',
              message: (response.data.status === 'approved') ? 'Obrigada! Seu pagamento já foi aprovado.' : 'Seu pagamento está sendo processado pelo Mercado Pago, em breve você receberá uma confirmação.'
            }
            vue.getInfo(true)
          } else if (data.payment_method === 'pix') {
            if (response.data.pix) {
              vue.pix.code = response.data.pix.qr_code
              vue.pix.qrCode = 'data:image/png;base64,' + response.data.pix.qr_code_base64
              vue.openPixResponse = true
              vue.pixUpdateCounter = 0
              vue.getPixUpdate()
            }
          } else {
            window.location = response.data.bank_slip.url
            /* if (response.data.bank_slip && response.data.bank_slip.barcode) {
              vue.bankSlip.barcode = response.data.bank_slip.barcode
              vue.bankSlip.url = response.data.bank_slip.url
              vue.openBankSlipResponse = true
            } else {
              window.location = response.data.bank_slip.url
            } */
          }
        })
        .catch((error) => {
          if (data.credit_card) {
            vue.openCreditCardResponse = true
            if (error.response && error.response.status === 401) {
              let errorMessage = 'Não conseguimos processar seu pagamento. Verifique com a sua operadora do cartão'

              switch (error.response.data && error.response.data.status_detail) {
                case 'cc_rejected_bad_filled_card_number':
                case 'cc_rejected_bad_filled_date':
                case 'cc_rejected_bad_filled_other':
                case 'cc_rejected_bad_filled_security_code':
                  errorMessage = 'Por favor, revise os dados inseridos do cartão'
                  break
                case 'cc_rejected_call_for_authorize':
                  errorMessage = 'Você precisa ligar para o seu cartão liberando o pagamento. E então tentar novamente'
                  break
                case 'cc_rejected_high_risk':
                  errorMessage = 'Você pode tentar com outro cartão ou entrar em contato com o nosso suporte. Nós podemos te dar mais detalhes do que pode ter ocorrido'
                  break
                case 'cc_rejected_insufficient_amount':
                  errorMessage = 'Não tem saldo suficiente no seu cartão'
                  break
                case 'cc_rejected_invalid_installments':
                  errorMessage = 'Seu cartão não aceita parcelar com essa quantidade de parcelas. Diminua e tente novamente'
                  break
                case 'cc_rejected_card_type_not_allowed':
                  errorMessage = 'Seu cartão não tem a função crédito habilitada'
                  break
              }

              vue.statusCreditCardResponse = {
                status: 'rejected',
                title: 'Pagamento recusado',
                message: errorMessage
              }
            } else {
              vue.statusCreditCardResponse = {
                title: 'Problema no Servidor',
                message: 'Desculpe, mas houve um erro no nosso servidor ao tentar processar o seu cartão de crédito, por favor tente novamente.'
              }
            }
            vue.creditCardKey++
            window.location = '#creditCardPayment'
            vue.sending = false
          } else {
            vue.sending = false
            vue.openBankSlipError = true
          }
        })
    },
    getInfo (isUpdating) {
      let vue = this
      if (!isUpdating) vue.loading = true

      axios.get('invoices/' + vue.id)
        .then((response) => {
          if (response.data) {
            vue.type = response.data.product_reference
            vue.monthReference = response.data.invoice_date
            vue.celebration = (response.data.product_reference === 'experience' && response.data.owner) ? response.data.owner.name : response.data.description
            vue.productReference = response.data.product_reference || ''
            vue.invoiceDescription = (response.data.product_reference === 'experience' && response.data.owner) ? response.data.description : null
            vue.status = (!isUpdating || response.data.invoice_status !== 'synchronize') ? response.data.invoice_status : vue.status
            vue.customerDocument = (response.data.customer) ? response.data.customer.document : ''
            vue.customerName = (response.data.customer) ? response.data.customer.name : ''
            vue.customerEmail = (response.data.customer) ? response.data.customer.email : ''
            vue.customerPhone = (response.data.customer) ? (response.data.customer.phone || response.data.customer.phone_number) : ''
            vue.customerID = (response.data.customer) ? response.data.customer.id : ''
            vue.customerAddress = (response.data.customer) ? response.data.customer.address : {}
            vue.financialDocument = (response.data.account && response.data.account.owner) ? response.data.account.owner.document : ''
            vue.financialName = (response.data.account) ? response.data.account.name : ''
            vue.financialAccount = (response.data.account) ? response.data.account.account_number : ''
            if (response.data.items) {
              vue.items = response.data.items.filter(e => !['interest_and_fines', 'discount'].includes(e.category)).map(e => {
                return {
                  qty: e.quantity,
                  type: e.category,
                  description: e.description,
                  value: e.amount
                }
              })
              vue.others = response.data.items.filter(e => e.category === 'interest_and_fines').map(e => {
                return {
                  description: e.description,
                  value: e.amount
                }
              })
              vue.discounts = response.data.items.filter(e => e.category === 'discount').map(e => {
                return {
                  description: e.description,
                  value: e.amount
                }
              })
            }
            vue.dueDate = response.data.due_date
            vue.paymentDate = response.data.payment_date
            vue.paymentInfo = {
              method: (response.data.payment_method) ? response.data.payment_method : '',
              installments: (response.data.installments) ? response.data.installments : 0,
              total: (response.data.total_amount) ? response.data.total_amount : 0
            }

            if (response.data.fees) {
              vue.fees = {}
              for (let i = 0, l = response.data.fees.length; i < l; i++) {
                let feeType
                if (response.data.fees[i].type === 'bank_slip') feeType = 'bankSlip'
                if (response.data.fees[i].type === 'pix') feeType = 'pix'
                if (response.data.fees[i].type === 'credit_card') feeType = 'creditCard' + response.data.fees[i].installment

                if (feeType) {
                  vue.fees[feeType] = {
                    id: response.data.fees[i].id,
                    value: response.data.fees[i].fee,
                    type: response.data.fees[i].method,
                    increment: (response.data.fees[i].processing_mode === 'increment')
                  }
                }
              }
            }
            if (vue.status === 'paid') {
              vue.openPixResponse = false
              clearTimeout(vue.pixTimeout)
              vue.pixTimeout = null
            }
            // if (vue.canPaid) {
            //   const lastBankSlipGeneratedArray = response.data.gateway_responses && response.data.gateway_responses.filter(gr => this.$moment(gr.date_of_expiration, 'YYYY-MM-DD HH:mm').isAfter() && gr.payment_type === 'ticket')
            //   vue.lastBankSlipGenerated = lastBankSlipGeneratedArray.length > 0 ? lastBankSlipGeneratedArray[lastBankSlipGeneratedArray.length - 1] : null
            // }
          } else {
            vue.SET_ERROR_PAGE('Error404')
          }
          vue.loading = false
        })
        .catch((error) => {
          if (error.response && error.response.status === '404') {
            vue.SET_ERROR_PAGE('Error404')
          } else {
            vue.SET_ERROR_PAGE('Error500')
          }
        })
    },
    getPixUpdate () {
      clearTimeout(this.pixTimeout)
      if (this.pixUpdateCounter < 15) {
        this.pixTimeout = setTimeout(() => {
          this.getInfo(true)
          this.getPixUpdate()
          this.pixUpdateCounter++
        }, 20000)
      }
    },
    copyLink () {
      const codeToCopy = this.$refs['input-copy']
      codeToCopy.select()
      codeToCopy.setSelectionRange(0, 99999)
      document.execCommand('copy')

      this.copiedLink = true
      setTimeout(() => {
        this.copiedLink = false
        window.getSelection().removeAllRanges()
      }, 6000)
    },
    handleApiCapture (event) {
      const { url, data } = event.detail

      console.log('Capturado com sucesso:', url, data)

      // Exemplo: Filtrar apenas as chamadas da biblioteca que você quer
      if (url.includes('api-da-biblioteca.com')) {
        console.log('Capturado com sucesso:', data)
        this.lastApiData = data
      }
    }
  },
  async created () {
    if (this.id) {
      this.getInfo()
      try {
        const result = await axios.get('get-token', {
          baseURL: 'https://n8n-payments.heppi.io/webhook/',
          auth: {
            username: 'heppi-payment',
            password: 'quinze-matagal-pires-barco-09983'
          }
        })
        console.log(result)
        this.getnetToken = result?.data?.access_token
      } catch (error) {
        console.log(error)
      }
    } else {
      this.SET_ERROR_PAGE('Error404')
    }
  }
}
</script>
